import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPencil3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPencil3"><Path fillRule="evenodd" clipRule="evenodd" d="M14.543 3.54222C16.1761 1.90943 18.8239 1.90943 20.457 3.54222C22.0901 5.17529 22.0899 7.82309 20.457 9.45628L9.48633 20.427L2.25781 21.7414L3.57227 14.5129L14.543 3.54222ZM13.4395 9.50023L14.5 10.5608L18.5605 6.50023L17.5 5.43968L13.4395 9.50023Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPencil3;
